import { encode, decode } from './encryption'

const get = (key: string, applyDecoding = false) => {
  let value = localStorage.getItem(key)

  if (!value) return null
  if (applyDecoding) value = decode(value)

  value = JSON.parse(value)
  return value
}

const getRaw = (key: string) => {
  const value = localStorage.getItem(key)

  if (!value) return null

  return value
}
const set = (key: string, value: any, applyEncoding = true) => {
  value = JSON.stringify(value)

  if (applyEncoding) value = encode(value)

  localStorage.setItem(key, value)
}
const remove = (key: string) => {
  localStorage.removeItem(key)
}

export default {
  get,
  getRaw,
  set,
  remove,
}
